import {CAMPAIGN_KEYS} from "@/api/campaignApi";
import {COMPANY_KEYS} from "@/api/companyApi";
import {USER_KEYS} from "@/api/userApi";
import {queryClient} from "@/queryClient";
import type {TCampaign, TCompanyProfile, TUserState} from "@/store/types";
import type {AxiosResponse} from "axios";

export const fetchUser = async (id: number) => {
  const cachedUser = queryClient.getQueryData<AxiosResponse<TUserState>>(USER_KEYS.qUser(id));

  if (cachedUser) {
    return cachedUser.data;
  }

  return (
    await queryClient.fetchQuery<AxiosResponse<TUserState>>({
      queryKey: USER_KEYS.qUser(id),
    })
  )?.data;
};

export const fetchCompany = async (id: number) => {
  const cachedCompany = queryClient.getQueryData<AxiosResponse<TCompanyProfile>>(COMPANY_KEYS.qCompany(id));

  if (cachedCompany) {
    return cachedCompany.data;
  }

  return (
    await queryClient.fetchQuery<AxiosResponse<TCompanyProfile>>({
      queryKey: COMPANY_KEYS.qCompany(id),
    })
  )?.data;
};

export const fetchCampaign = async (id: number) => {
  const cachedCampaign = queryClient.getQueryData<AxiosResponse<TCampaign>>(CAMPAIGN_KEYS.qCampaign(id));

  if (cachedCampaign) {
    return cachedCampaign.data;
  }

  return (
    await queryClient.fetchQuery<AxiosResponse<TCampaign>>({
      queryKey: CAMPAIGN_KEYS.qCampaign(id),
    })
  )?.data;
};
